import { Globe, ArrowUpRight } from "lucide-react";

const WEBSITE_URL = "https://www.dsaecommerce.com";

// Bottom CTA inviting visitors to the main marketing site.
export default function WebsiteCTA() {
  return (
    <section
      className="w-full bg-white px-5 py-16 text-center md:py-20"
      data-testid="website-cta-section"
    >
      <div className="mx-auto max-w-2xl">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand/10 text-brand">
          <Globe className="h-6 w-6" strokeWidth={1.75} aria-hidden="true" />
        </span>
        <h2 className="mt-6 text-2xl font-black tracking-tight text-brand-ink md:text-3xl">
          Want to learn more about us first?
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-neutral-600">
          See how we build and run done-for-you Amazon &amp; Walmart stores for
          400+ clients.
        </p>
        <a
          href={WEBSITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="website-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-black uppercase tracking-wide text-white transition-colors duration-200 hover:bg-brand-dark"
        >
          Visit dsaecommerce.com
          <ArrowUpRight className="h-4 w-4" strokeWidth={3} aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
